import React from 'react';
import MaterialTableBody, {
    TableBodyProps as MaterialTableBodyProps,
} from '@mui/material/TableBody';
import styled from 'styled-components';

const StyledTableBody = styled(({ ...props }: MaterialTableBodyProps) => (
    <MaterialTableBody {...props} />
))`
    th,
    td {
        padding: 0.825rem 1rem;
        font-size: 1rem;
        color: #111111;
    }
`;
export interface TableBodyProps extends MaterialTableBodyProps {
    component?: React.ElementType;
}

const TableBody: React.FunctionComponent<TableBodyProps> = ({ children, ...props }) => {
    return <StyledTableBody {...props}>{children}</StyledTableBody>;
};

export default TableBody;
